import { noConflict } from "lodash";
import { title } from "process";

export default {
  auth: {
    login: 'Login',
    logout: 'Logout',
    no_match: 'Your passwords do not match',
    forgot: {
      title: 'Forgot password',
      instruction: 'Enter your email address to receive an email how to create a new password.',
      confirmation: 'A new password has been send to your email.',
      submit: 'Recover',
    },
    reset: {
      title: 'Reset password',
      description: 'Create a new password.',
      submit: 'Reset',
      submitted: 'Your password has been updated.'
    },
    submitted: {
      success: 'Done!',
      sent: 'We have sent you  email to {email}.',
      again: 'Log in again',
    },
    required: {
      email: 'Invalid email',
      password: 'Password is required',
      default: 'Required',
      name: 'Invalid name',
      url: 'Invalid url',
      number: 'Only numbers allowed',
      passwordRules: {
        lowercase: 'One lowercase letter required',
        uppercase: 'One uppercase letter required',
        length: '8 characters minimum',
        number: 'One number required',
        special: 'One special character required',
        match: 'The passwords must match',
      },
    },
  },
  actions: {
    back: 'Back',
    next: 'Next',
    add: 'Add',
    edit: 'Edit',
    save: 'Save',
    create: 'Create',
    close: 'Close',
    esc: 'esc',
  },
  labels: {
    description: 'Description',
  },
  event: {
    title: 'Hour registration',
    dialog: {
      create: 'Create',
      edit: 'Edit',
      remove: 'Delete',
    },
  },
  user: {
    add: 'add {item}',
    title: 'User',
    statuses: {
      active: 'Active',
      blacklist: 'Blacklist',
      discontinued: 'Discontinued',
      openInvoice: 'Open invoice',
    },
  },
  mfa: {
    title: 'mfa token',
  },
  roles: {
    user: 'User | Users',
    title: 'User'
  },
  request:
  {
    request: 'Request',
    boxRequestNotFound: 'Box request not found or cannot be loaded.',
    assignedAt: 'Assigned on',
    noLogsAvailable: 'No logs available',
    statusChangedTo: 'status changed to',
    by: 'by',
  },
  table: {
    found: '{total} {name} found',
    perPage: '{name} per page:',
    noData: 'No data available',
    filter: 'Filter on {name}:',
    listView: 'List view',
    kanBanView: 'Kanban view',
    toggleFilters: 'Toggle filters',
  },
  tableHeaders: {
    name: {
      title: 'Name',
      first: 'First Name',
      middle: 'Middle Name',
      last: 'Last Name',
    },
    age: {
      title: 'Age',
    },
    email: {
      title: 'Email'
    },
    phone: {
      title: 'Phone'
    },
    created_at: {
      title: 'Created at',
    },
    price: {
      title: 'Price',
    },
    code: {
      title: 'Code',
    },
    percentage: {
      title: 'Percentage',
    },
    status: {
      title: 'Status',
    },
    adressChecked: {
      title: 'Address Checked',
    },
    city: {
      title: 'City',
    },
    number: {
      title: 'Number',
    },
    userID: {
      title: 'User ID',
    },
    createdAt: {
      title: 'Created At',
    },
    client: {
      title: 'Client',
    },
    type: {
      title: 'Type',
    },
    stylist: {
      title: 'Stylist',
    },
    note: {
      title: 'Note',
    },
    boxNumber: {
      title: 'Box #',
    },
    channel: {
      title: 'Channel',
    },
    assignedAt: {
      title: 'Assigned At',
    },
    lastStatusUpdate: {
      title: 'Last Status Update',
    },
    lastUpdate: {
      title: 'Last Update',
    },
    orderNumber: {
      title: 'Order #',
    },
    quantity: {
      title: 'QTY',
    },
    quantitySold: {
      title: 'QTY sold',
    },
    netSales: {
      title: 'Net Sales',
    },
    finalized: {
      title: 'Finalized',
    },
    deispatched: {
      title: 'Dispatched',
    },
    finalReturn: {
      title: 'Final Return',
    },
    returned: {
      title: 'Returned',
    },
    picked: {
      title: 'Picked'
    },
    barcode: { title: 'Barcode' },
    offeredOn: { title: 'Offered on' },
    deliveryDate: { title: 'Delivery date' },
    labels: { title: 'Labels' },
    understanding: { title: 'Understanding' },
  },
  navigation: {
    users: 'Users',
  },
  profile: {
    referral_code: 'Referral code',
    title: 'Profile | Profiles',
    setting: 'Setting | Settings',
    mine: 'My Profile',
    standard: 'Standard Information',
    contact: {
      information: 'Contact Information',
      person: 'Contact person',
      number: 'Contact number',
    },
    dob: 'Date of Birth',
    name: 'Name',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phonenumber',
    website: 'Website',
    country: 'Country',
    password: {
      title: 'New Password',
      forgot: 'Forgot your password?',
      current: 'Current password',
      confirm: 'Confirm password',
      change: 'Change password',
      save: 'Save password',
      saved: 'Password saved',
    },
    group: 'Group',
    login: 'Login as',
    address: 'Address',
    street: 'Street',
    housenumber: 'House number',
    addition: 'Addition',
    postcode: 'Zip code',
    city: 'City',
    budgetHours: 'Budget Hours',
    budgetMoney: 'Budget Money',
    code: 'Code',
    color: 'Color',
    invoiceName: 'Invoice name',
    calculationModel: 'Calculation Model',
    responsibleEmployee: 'Employee',
  },
  avatar: {
    title: 'Profile picture',
    change: 'Change picture',
  },
  general: {
    back: 'Back',
    search: 'Search | Search',
    cancel: 'cancel',
    yes: 'Yes',
    no: 'No',
    active: 'Active',
    inactive: 'Inactive',
    startsAt: 'Starts at',
    endsAt: 'Ends at',
  },
  time: {
    year: 'year | years',
    month: 'month | months',
    week: 'week | weeks',
    day: 'day | days',
    hour: 'hour | hours',
    minute: 'minute | minutes',
  },
  inbox: {
    title: '',
    menu: {
      inbox: 'Inbox',
      starred: 'Starred',
      sent: 'Sent',
      draft: 'Draft',
      create: 'New email',
      folders: 'Folders',
    },
    actions: {
      delete: 'Delete',
      reply: 'Reply',
      archive: 'Archive',
      sent: 'Sent'
    },
    contact: 'Contact | Contacts'
  },
  form: {
    formFields: {
      avatar: 'Avatar',
      supplierName: 'Supplier name',
      firstName: 'First name',
      lastName: 'Last name',
      middleName: 'Middle name',
      name: 'Name',
      invoiceName: 'Invoice name',
      website: 'Website',
      phone: 'Phone',
      username: 'Username',
      email: 'Email',
      password: 'Password',
      category: 'Category',
      confirmPassword: 'confirm password',
      code: 'Code',
      percentage: 'Percentage',
      color: 'Project color',
      token: 'MFA Token',
      value: 'Value',
      country: {
        title: 'Land',
        nl: 'Netherlands',
        en: 'England',
        de: 'Germany',
      },
    },
    optional: 'Optioneel',
    fieldsRequiredText: 'Alle velden zijn verplicht',
  },
  languages: {
    title: 'Language',
    nl: 'Dutch',
    en: 'English',
    de: 'German'
  },
  createDialog: {
    header: {
      create: 'Create',
      overview: 'Overview',
      finished: 'Finished',
    },
    body: {
      title: {
        activate: 'Activate the {role}',
        create: 'Create a new {role}',
        finished: '{role} is created',
        information: '{role} information',
        address: 'Debtor address',
        postAddress: 'Post address',
        officeAddress: 'Visitation Address',
      },
      description: {
        confirm: 'Confirm all information is correct for the new {role}',
        finished: 'View the created below {role}',
      },
      upload: 'Upload',
    },
    actions: {
      reset: 'Create another {role}',
    },
  },
  dialogOptions: {
    item: {
      client: 'Client',
      subscriptionType: 'Subscription type',
    },
    confirmation: 'Confirmation',
    delete: 'Are you sure you want to delete this {item}? | Are you sure you want to delete these {item}?',
    deleteMany: 'Are you sure you want to delete {item}?',
    lessonT: 'Are you sure you want to go to this {item}?',
    save: '{item} is saved',
    update: 'Are you sure you want to update this {item}? | Are you sure you want to update these {item}?',
    existingOrderFound: 'Existing order found',
    existingOrderFoundForClient: 'There is already an order for this client',
    showOrder: 'Show order',
    button: {
      delete: 'Delete',
      cancel: 'Cancel',
      ok: 'Ok',
    },
  },
  bugReport: {
    title: 'Bug',
    header: 'Report a bug',
    field: {
      title: 'Title',
      description: 'Description',
      screenshot: 'Screenshot',
    },
    create: {
      title: 'Add a title',
      description: 'Add a description.',
      descriptionExplanation: 'When did this bug occur? Which steps and /or actions did you go through? Which buttons did you click?',
      screenshot: 'Screenshot',
      submitBug: 'Submit bug',
      created: 'Your Bug report has been created.',
      downloadScreenshot: 'Download the image',
      uploadScreenshot: 'Upload the downloaded image in the link',
    },
    alert: {
      noIdSet: 'Monday Board Id or Group Id has not been set, cannot create a pulse',
      warning: 'Warning',
    },
    reportContent: {
      description: 'Description',
      localStorage: 'Local storage',
      stacktrace: 'Stacktrace',
      message: 'Message',
      file: 'File',
      line: 'Line',
      column: 'Column',
      error: 'Error',
    },
  },
  errors: {
    loading: {
      description: 'There was a problem loading the required information.',
      suggestion: 'Please try again later.',
    },
    notFound: {
      description: 'The page you were looking for could not be found.',
      suggestion: '404',
      url: 'Please check the url for any typos',
      error: '404 ERROR.',
      back: 'go to home',
      oops: 'Oops :(',
      or: 'or',
      contact: 'contact us via',
    },
  },
  hours: {
    hour: 'hour | hours',
  },
  contact: 'Contact',
  contacts: 'Contacts',
  menu: {
    requests: 'Requests',
    orders: 'Orders',
  },
  hamburgerMenu: {
    account: 'My Account',
    settings: 'Settings',
  },

  filters: {
    filters: 'Filters',
    statusFilter: {
      toBeContacted: 'To be contacted',
      waitingForReply: 'Waiting for reply',
      noReply: 'No reply',
      orderInProgress: 'To be styled',
      completed: 'Completed',
    },
    typeFilter: {
      swapBox: 'Swap Box',
      styledBox: 'Styled Box',
      studio: 'Studio',
      afterSales: 'After Sales',
      promotion: 'Promotion',
      supplierReturn: 'Supplier Return',
      swipeToShop: 'Swipe-to-shop',
      shopify: 'Shopify',
      stylingFee: 'Styling Fee',
      other: 'Other',
    },
    orderStatusFilter: {
      active: 'Active',
      inactive: 'Inactive',
      preview: 'Preview',
      finalized: 'Finalized',
      checkout: 'Checkout',
      invoiced: 'Invoiced',
      completed: 'Completed',
      lost: 'Lost',
      cancelled: 'Cancelled',
      allocated: 'Allocated',
      partiallyAllocated: 'Partially Allocated',
      picked: 'Picked',
      partiallyPicked: 'Partially Picked',
      shipped: 'Shipped',
      partiallyShipped: 'Partially Shipped',
      dispatched: 'Dispatched',
      partiallyDispatched: 'Partially Dispatched',
    },
    finalReturnDate: 'Final Return Date',
  },
  contactsPage: {
    cardview: {
      newOrder: 'Create New Order',
      editStatus: 'Edit Status',
      createNewOrder: 'Create New Order',
      finishOrder: 'Finish Order',
      fillAdress: 'Enter the address details and proceed with the order',

    },
    quizView: {
      styleQuiz: 'Stylequiz',
      quizCreatedAt: 'Quiz created at:',
      style: 'Style',
      bodyType: 'Body Type',
      preferences: 'Preferences',
      myFotos: 'My Photos',
      box: 'Box',
      notes: 'Stylist Notes',
    },
    attachments: 'Attachments',
    listView: {
      search: 'Search',
      signUpDate: 'Sign up date',
    },
  },
  orders: {
    checkOrder: 'View order',
    orderDetail: {
      orderItems: 'Order Items',
      relatedSets: 'Related Sets',
      evaluation: 'Evaluation',
      attachments: 'Attachments',
      labels: 'Labels',
      updateOrder: 'Update Order',
      orderItemsBlock: {
        notAllocatedItems: 'Not allocated items',
        itemName: 'Item Name',
        quantity: 'Quantity',
        price: 'Price',
        tax: 'Tax',
        total: 'Total',
        allocatedItems: 'Allocated items',
        noItemsAreAllocated: 'No items are allocated',
        pickedItems: 'Picked items',
        noItemsArePicked: 'No items are picked',
        dispatchedItems: 'Dispatched items',
        noItemsAreDispatched: 'No items are dispatched',
        returnedItems: 'Returned items',
        noItemsAreReturned: 'No items are returned',
        returnBatch: 'Return Batch',
        keptItems: 'Kept items',
        discount: 'Discount',
        noItemsAreKept: 'No items are kept',
        totalUnits: 'Total units',
        subTotal: 'Subtotal',
        referralDiscount: 'Referral discount',
        includingVat: 'Including VAT (21%)',
        returnDate: 'Return date',
        orderDiscount: 'Order discount',
      },
      relatedSetsBlock: {
        newSet: 'New Set',
        size: 'Size:',
        brand: 'Brand:',
        editPersonalNote: 'Edit Personal Note',
        createdAt: 'Created At',
        cancel: 'Cancel',
      },
      evaluationBlock: {
        orderEvaluation: 'Order Evaluation',
        stylistUnderstanding: 'To what extent do you feel that your stylist has understood your style well?',
        anotherBox: 'Do you think you would like to receive another box?',
        satisfiedWithBox: 'To what extent are you satisfied with the box?',
        willYouAdvise: 'How likely are you to recommend Maison365 to others?',
        isTheChoiceGood: 'To what extent do you agree with the statement that Maison365 makes it easy to get nice clothes?',
      },
      orderedItemsEvaluation: {
        orderItemsEvaluation: 'Order Items Evaluation',
        product: 'Product',
        overall: 'Overall',
        fit: 'Fit',
        style: 'Style',
        other: 'Other',
        good: 'Good',
        size: 'size',
        tooLarge: 'Too large',
        tooSmall: 'Too small',
        keep: 'Keep',
        return: 'Return',
        exchange: 'Exchange',
        tooWide: 'Too wide',
        tooTight: 'Too tight',
        tooLong: 'Too long',
        tooShort: 'Too short',
        tooSimple: 'Too simple',
        tooBusy: 'Too busy',
        tooSolid: 'Too solid',
        tooYoung: 'Too young',
        colorNotNice: 'Color not nice',
        printNotNice: 'Print not nice',
        materialFinishingNotNice: 'Material/Finishing not nice',
        tooExpensive: 'Too expensive',
        alreadyHaveSomethingSimilar: 'I already have something similar',
        generalEvaluation: "Overall evaluation",
        sizeEvaluation: "Size evaluation",
        fitEvaluation: "Fit evaluation",
        styleEvaluation: "Style evaluation",
        otherEvaluation: "Other evaluation",
      },
      attachmentsBlock: {
        orderAttachments: 'Order Attachments',
        noOrderAttachments: 'There are no order attachments',
        seeOrderAttachments: 'See order attachments',
      },
      listView: {
        nanOrdersFound: 'NaN Orders found',
        search: 'Search',
        ordersPerPage: 'Orders per page',
      },
      webshop: {
        filters: {
          search: 'Search',
          colors: 'Colors',
          brands: 'Brands',
          suppliers: 'Suppliers',
          categories: 'Categories',
          tags: 'Tags',
          materials: 'Materials',
          price: 'Price',
          sizes: 'Sizes',
          season: 'Season',
          pantsLength: 'Pants: Length',
          details: 'Details',
          sustainable: 'Sustainable',
          pantsFit: 'Pants: Fit',
          jacketsFit: 'Jackets: Fit',
          dressesFit: 'Dresses: Fit',
          topsFit: 'Tops: Fit',
          collar: 'Collar',
          jacketsLength: 'Jackets: Length',
          dressesLength: 'Dresses: Length',
          topsLength: 'Tops: Length',
          sizeGuide: 'Size guide',
          material: 'Material',
          sleeveSize: 'Sleeve Size',
          pattern: 'Pattern',
          closure: 'Closure',
          style: 'Style',
          pantsType: 'Pants: Type',
          jacketsType: 'Jackets: Type',
          skirtType: 'Skirt: Type',
          rerun: 'Rerun',
          dummyUPC: 'Dummy UPC',
          removeAllFilters: 'Remove all filters',
        },
        styleView: {
          availableSizes: 'Available sizes',
        },
        sideBar: {
          height: 'Height',
          cup: 'Cup',
          jeans: 'Jeans',
          tops: 'Tops',
          topSize: 'Top Size',
          bottomSize: 'Bottom Size',
          customer: 'Customer',
          style: 'Style',
          brands: 'Brands',
          keywords: 'Keywords',
          dresscodeAtWork: 'Dresscode at work',
          monthlyBudget: 'Monthly budget',
          colors: 'Colors',
          shoppingCart: 'Shopping Cart',
          size: 'Size',
          total: 'Total:',
          createSets: 'Create Sets',
          client: 'Client',
          items: 'Items',
          colorDontUse: 'Which colors do you not wear',
          fabricDontUse: 'Which fabrics do you not wear',
          patternDontUse: 'Which patterns do you not wear',
          camouflage: 'Camouflage',
          motivation: 'Motivation',
          thisBox: 'This box',
          lookingFor: 'Mainly looking for',
          specificItems: 'Specific items that the customer wants to receive',
          other: 'Other',
          shapePreferenceTops: 'Fit preference for tops',
          budget: 'Budget',
          trousers: 'Trousers',
          fittingTrousers: 'How do trousers usually fit you at the waist?',
          skirts: 'Skirts',
          dresses: 'Dresses',
          lengthSkirt: 'What skirt length suits you?',
          accessories: 'Accessories',
          describeAccessories: 'How would you describe your style for accessories and jewelry?',
          preferenceColor: 'Preferred jewelry color',
          earsPierced: 'Do you have pierced ears?',
          noProductsCart: 'There are no products in the cart',
        },
        productView: {
          backToTheShop: 'Back to the shop',
          inStock: 'In Stock',
          productDetailsPhotosOkNotOk: 'Product details & photos OK/NOT OK for color Dark blue, size 36?',
          addToCart: 'Add to Cart',
          color: 'Color',
          productAttributes: 'Product Attributes',
          supplierCode: 'Supplier Code',
          location: 'Location',
          selectOtherSize: 'Select a different size',
          outOfStock: 'Out of stock',
          productAlreadyInCart: 'This product is already in your cart',
          availableInShopify: 'Available in Shopify',
          reserved: 'Reserved',
          noMaterials: 'No materials for this product',
          noTags: 'No tags for this product',
        },
        sets: {
          addAllToOtherItems: "Add all to 'Other items'",
          otherItems: 'Other Items',
          totalPrice: 'Total price:',
          totalProducts: 'Total products:',
          createPersonalNote: 'Create Personal Note',
          newSet: 'New Set',
          back: 'Back',
          tip: 'TIP:',
          packInThisSet: 'Pack in this set',
          setExplanation: 'Set explanation',
        },
        personalNote: {
          personalNote: 'Personal Note',
          updatePersonalNote: 'Update Personal Note',
          totalPrice: 'Total price:',
          totalProducts: 'Total products:',
          finalizeThisOrder: 'Finalize this order',
          introText: 'Intro Text',
          noExplanationForSet: 'No explanation has been given for this set',
          outroText: 'Outro Text',
          back: 'Back',
          originalText: 'Original text',
          selectLanguageNote: 'Select the Personal Note language for your customer',
          inOriginalLanguage: 'Display in original language',
          translateToOtherLanguage: 'Translate to another language',
          selectLanguage: 'Select language',
          translate: 'Translate',
          translatedText: 'Translated text',
          orderSucceded: 'Order succeeded',
          orderDefinitive: 'The order has been finalized.',
          orderOverview: 'Go to the order overview',
          editPersonalNotes: 'Edit Personal Notes',
          update: 'Update',
          cancel: 'Cancel',
          sureYouWantToUpdate: 'Are you sure you want to update the personal note?',
        },
        maia: {
          name: 'Maia',
          subtitle: 'Styling Support',
          openChat: 'Ask Maia',
          you: 'You',
          placeholder: 'Type a message..',
          viewProduct: 'View product',
          greeting: 'Hi! I\'d love to help you put this box together. Where would you like to start?',
          greetingNamed: 'Hi! I\'d love to help you with the box for {customer}. Where would you like to start?',
          error: 'Sorry, I could not fetch an answer just now. Please try again.',
          suggestions: {
            jeans: 'Which jeans suit this customer?',
            eyeCatcher: 'Suggest an eye-catcher under €150',
            missing: 'What is this box still missing?',
          },
          // The crosscheck against the customer profile, per recommendation.
          // The keys come from the backend (MaiaRecommendationCheck) so the
          // wording lives in the stylist's language rather than the model's.
          checks: {
            notChecked: 'Cannot be checked',
            over: '{amount} over budget',
            breaks: 'wrong {rule}',
            rules: {
              size: 'size',
              colour: 'colour',
              dress: 'no dress',
              budget: 'budget',
              wishlist: 'on her wishlist',
              fabric: 'fabric',
              print: 'print',
              camouflage: 'camouflage',
              profile: 'no profile',
            },
          },
        }
      }
    }
  },
  mfaSetup: {
    mfaNotYetSetup: 'MFA not yet set up',
    mfa: "Set up MFA",
    mfaSetup: "Set up MFA token",
    step1: "Grab your phone.",
    step1_ios: 'If you have an <b>iPhone</b>, open the App Store and search for <b>"Step Two"</b>.',
    step1_android: 'If you have an <b>Android phone</b>, open the Play Store and search for <b>"Google Authenticator"</b>.',
    step1_download: "Then download this app on your phone.",
    step2: "Open the newly downloaded app and add the token",
    step2_steptwo: '<b>Step Two</b>: Tap the + icon and scan the QR code below:',
    step2_google: '<b>Google Authenticator</b>: Start setup and tap “Scan barcode”.',
    step2_scan: "Now scan the QR code below.",
    step3: "After scanning the QR code, you will see a 6-digit code with a timer. This code expires every 30 seconds.",
    step4: 'Enter the code from your app in <b>"Token 1"</b>.',
    step5: "Wait until the code expires, then enter the new code in <b>'Token 2'</b>.",
    step6: 'Finish setup by clicking <b>"Save Token"</b>.',
    token1_label: "Token 1",
    token2_label: "Token 2",
    save_token: "Save Token",
    cancel: "Cancel",
  },

};

